import { render, staticRenderFns } from "./OrganizationWrapper.vue?vue&type=template&id=d3cb1638&scoped=true"
import script from "./OrganizationWrapper.vue?vue&type=script&lang=js"
export * from "./OrganizationWrapper.vue?vue&type=script&lang=js"
import style0 from "./OrganizationWrapper.vue?vue&type=style&index=0&id=d3cb1638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cb1638",
  null
  
)

export default component.exports